import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUserData } from 'reduxBits/privateProfile/actions'
import { actionCreators as authActionCreators } from '@blocket/authentication-fe'
import { removeConnectProperties } from 'reduxBits/chat/actions'
import { mediaQueries, withDevice } from 'plugins/device'
import { TextHeadline1, Divider, Button } from '@blocket/blocket-ui'
import styled from 'styled-components'
import TabBar from 'components/sharedComponents/TabBar'
import Footer from 'components/sharedComponents/Footer'
import Loading from 'components/sharedComponents/ProfileCard/Loading'
import { profilePagePrivateView } from 'tracking/profilePagePrivate'
import ProfileData from './components/ProfileData'
import Cards from './components/Cards'

const ContentWrapper = styled.main`
  align-self: center;
  flex-grow: 1;
  padding: 0 16px;
  margin-bottom: 16px;
  width: 100%;
  max-width: 980px;
  @media ${mediaQueries.large} {
    padding: 0;
  }
`

const TopWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`

const ProfileContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

const CardSection = styled.div`
  padding: 24px 0;
`

const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  margin-top: 24px;
  @media ${mediaQueries.large} {
    grid-template-columns: repeat(3, 1fr);
  }
`
const LogOutButton = styled(Button)`
  max-width: 100px;
  margin-top: 24px;
`

const ProfilePage = ({ device, router }) => {
  const [trackingViewSent, setTrackingViewSent] = useState(false)
  const profileData = useSelector((state) => state.privateProfile.userProfileData)

  const dispatch = useDispatch()
  const redirectUrl = router.pathname

  useEffect(() => {
    dispatch(fetchUserData())
  }, [dispatch])

  useEffect(() => {
    if (!trackingViewSent) {
      profilePagePrivateView()
      setTrackingViewSent(true)
    }
  }, [trackingViewSent])

  const logOut = (e) => {
    e.preventDefault()
    dispatch(authActionCreators.blocketLoginHelper.logout(redirectUrl))
  }

  return (
    <ProfileContainer>
      <TabBar />
      <ContentWrapper>
        <TopWrapper>
          {profileData ? <ProfileData profileData={profileData} /> : <Loading />}
        </TopWrapper>
        <Divider />
        <CardSection>
          <TextHeadline1 tagName="h2">Mitt Blocket</TextHeadline1>
          <CardsWrapper>
            <Cards device={device} />
          </CardsWrapper>
        </CardSection>
        <Divider />
        <LogOutButton
          size="tiny"
          onClick={(e) => {
            logOut(e)
            // removes chat connect credentials from local storage
            dispatch(removeConnectProperties())
          }}
        >
          Logga ut
        </LogOutButton>
      </ContentWrapper>
      <Footer />
    </ProfileContainer>
  )
}

ProfilePage.propTypes = {
  device: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
}

export default withRouter(withDevice(ProfilePage))
